import styled from "styled-components";

export const StyledWrapper = styled.div`
  .page-heading {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    }

    .page-controls {
      background-color: ${({ theme }) => theme.colors.primaryText};
      border-radius: 24px;

      &:focus-visible {
        outline: none;
      }

      button {
        padding: 4px 12px;
        color: ${({ theme }) => theme.colors.neutralsWhite};
        ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopySmall}
        background-color: transparent;
        border: 0;
        cursor: pointer;

        &.active {
          color: ${({ theme }) => theme.colors.primaryText};
          background-color: ${({ theme }) => theme.colors.neutralsWhite};
          border-radius: 24px;
          box-shadow: 0 0 0 0.1px ${({ theme }) => theme.colors.neutralsWhite};
          cursor: default;
          opacity: 1;
        }

        &:not(.active) {
          &:first-child {
            padding-right: 8px;
          }
          &:last-child {
            padding-left: 8px;
          }
        }

        &:focus-visible {
          outline: none;
        }
      }
    }
  }

  .page-timestamp {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopySmallItalic}
    text-align: right;
  }

  .content-wrapper {
    display: flex;
    gap: 16px;

    .content-column {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 25px;
    }
  }
`;
